import React, {useEffect, useState} from "react";
import styled from "styled-components";
import usePolicyStyles, {TableDiv, AlertBar} from "./policy-style";
import PolicyIconMedical from '../../assets/policyDetails/Icon-medical.svg';
import QnectButton from "../qnect-ui/qnect-button";
import MaterialUiTable from "../ui/material-ui-table/material-ui-table";
import {
    _getPlanList,
    _getPoliciesForUpdate,
    _getPolicy,
    _getPolicyList,
    _getSubsidiaryList, _retrieveMemberList,
    _retrieveMembers, _storeMemberList,
    _storePoliciesForUpdate,
    _storePolicyList,
    _syncMemberList
} from "../../store/policy/service";
import {_getLang, _hideSpinner, _showSpinner} from "../../store/system/service";
import {useHistory, withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {
    _formatDate,
    _formatDateTimeZone,
    generateMemberId, getGenderLabel,
    getParentMemberOptions,
    getRelationshipLabel
} from "../../utils/utility";
import moment from "moment";
import useConfig from "../qnect-ui/qnect-config";
import AddUserDialog from "./add-user-dialog";
import EditUserDialog from "./edit-user-dialog";
import DeleteUserDialog from "./delete-user-dialog";
import ViewUserDialog from "./view-user-dialog";
import RedInfoIcon from '../../assets/info_red-on-white.svg';
import ScrollToTopButton from "../ui/scroll-to-top/scroll-to-top";


const StyledNameDiv = styled.div`
    color: #003DA5;
    cursor: pointer;
    
`;

const StyledBreadCrumbDiv = styled.div`
    font-family: Inter-Regular;
    font-size: 12px;
    display: flex;
    & > div:first-child {
        border-bottom: 2px solid rgba(98,112,136,0.4);
    }
    
    & > div {
        border-bottom: 2px solid black;
        padding-bottom: 5px;
        cursor: pointer;
    }
`;

const TitleDiv = styled.div`
    margin-top: 48px;
    font-family: Stag-Medium;
    color: #0A1F44;
    font-size: 32px;
`;

const PolicyDiv = styled.div`
    margin-top: 46px;
    box-sizing: border-box;
    height: 157px;
    width: 1251px;
    border: 1px solid #E1E4E8;
    border-radius: 10px;
    background-color: #FFFFFF;
    box-shadow: 2px 2px 8px 0 rgba(20,40,75,0.2);
    
    @media (max-width: 1251px) and (min-width: 1024px) {
        width: 100%;
    }
    
    & > div.insideDiv {
        margin-top: 32.5px;
        margin-left: 40.5px;
        width: 1041px;
        display: flex;
        @media (max-width: 1251px) and (min-width: 1024px) {
            width: 100%;
        }
        
        & > div {
            flex-basis: 100%;
            display: flex;
            
            & > div.iconDiv {
                margin-right: 25px;
            }   
        }
    }
    
    .normal {
        font-size: 16px;
        font-family: Inter-Regular;
    }
    
    .bold {
        font-size: 20px;
        font-family: Inter-Medium;
    }
    
    div.policyNumberDiv > div:first-child {
        margin-bottom: 5px;
    }
`;

const SubsidiaryTitleDiv = styled.div`
    margin-top: 30px;
    font-family: Stag-Medium;
    font-size: 20px;
    color: #0A1F44;
`;

const PolicyDetail = (props) => {
    const cfg = useConfig(props.lang);
    const classes = usePolicyStyles(props);
    const [openAddUserDialog, setAddUserDialog] = useState(false);
    const [openEditUserDialog, setEditUserDialog] = useState(false);
    const [openDeleteUserDialog, setDeleteUserDialog] = useState(false);
    const [openUserDetailsDialog, setUserDetailsDialog] = useState(false);
    const [data, setData] = useState([]);
    const [parentMembers, setParentMember] = useState([]);
    const [userDetail, setUserDetail] = useState(null);
    const [changed, setChanged] = useState(false);
    const [maxIdsOnMemberObject, setMaxIdsOnMemberObject] = useState();
    const history = useHistory();

    useEffect(() => {
        let memberList = props.policyList[props.policy.policyIndex]
            .subsidiaryList[props.policy.subsidiaryIndex]
            .planList[props.policy.planIndex].memberList;

        if (memberList && memberList.length > 0) {
            // skip empty i
            if (memberList[0].subsidiaryNo) {
                setData(memberList);
            }
        } else {
            props.showSpinner();
            props.retrieveMembers(props?.policy?.planId).then((response) => {
                if (response) {
                    let memberList = response.map(obj => {
                        let displayObj = Object.assign({}, obj);
                        displayObj.effectiveDate = _formatDateTimeZone(obj.effectiveDate);
                        displayObj.employmentDate = _formatDateTimeZone(obj.employmentDate);
                        displayObj.dateOfBirth = _formatDateTimeZone(obj.dateOfBirth);
                        displayObj.memberNo = obj?.memberNo?.padStart(6, "0");
                        displayObj.policyNumber = obj?.policyNumber;
                        displayObj.subsidiaryNo = props.policy.subsidiaryNo;
                        displayObj.subsidiaryName = props.policy.subsidiaryName;
                        displayObj.planId = obj?.planId;
                        displayObj.planName = obj?.planName;
                        displayObj.relationship = obj?.relationship;
                        displayObj.parentMember = obj?.parentMember;
                        displayObj.parentMemberName = obj?.parentMemberName;
                        displayObj.lastServiceDate = _formatDate(obj?.lastServiceDate);
                        displayObj.name = obj.name;
                        displayObj.gender = obj.gender;
                        displayObj.emailAddress = obj.emailAddress;
                        displayObj.allowModify = props.policy.allowModify;
                        displayObj.allowDelete = props.policy.allowDelete;
                        return displayObj;
                    });
                    setData(memberList);
                    props.syncMemberList(memberList);
                }
                props.hideSpinner();
            }, () => {
                console.log('no data');
                props.hideSpinner();
            });

        }
    }, []);

    const sortingFunc = (a,b) => a-b;

    useEffect(() => {
        //compute max ID here
        if (data.length > 0) {
            let finalObj = {
                maxSelfNo: 0
            };
            data.forEach((mmbr) => {
                // if ID has '-'
                if (mmbr?.memberNo.includes('-')) {
                    let memberIdFullArr = mmbr?.memberNo.split('-');
                    if (memberIdFullArr.length > 1) {
                        let selfNo = Number(memberIdFullArr[0]);
                        let dependentNo = Number(memberIdFullArr[1]);

                        finalObj[selfNo] = {
                            spouseList: [],
                            childList: []
                        }

                        // assign max self no from the members in the object
                        if (selfNo > finalObj.maxSelfNo) {
                            finalObj.maxSelfNo = selfNo;
                        }

                        // if spouse or child
                        if (dependentNo > 0) {
                            if (dependentNo == 1 || (dependentNo >= 31 && dependentNo <= 99 )) {
                                finalObj[selfNo].spouseList.push(dependentNo);
                            } else if ((dependentNo >= 2 && dependentNo <= 20) || dependentNo >= 100) {
                                finalObj[selfNo].childList.push(dependentNo);
                            }
                        }
                    }
                }
            });

            //sort elements in the list. this will be used on delete member
            const keys = Object.keys(finalObj);
            keys.forEach((k) => {
                if(!isNaN(k)) {
                    finalObj[k].spouseList.sort(sortingFunc);
                    finalObj[k].childList.sort(sortingFunc);
                }
            })
            setMaxIdsOnMemberObject(finalObj);
        }
    }, [data])

    const callViewUserDialog = (rowData) => {
        setUserDetail(rowData);
        setUserDetailsDialog(true);
    }

    const callEditUserDialog = (rowData) => {
        setUserDetail(rowData);
        setEditUserDialog(true);
    }

    const callDeleteUserDialog = (rowData) => {
        setUserDetail(rowData);
        setDeleteUserDialog(true);
    }

    const addMember = (memberData) => {
        console.log('addMember', memberData);
        memberData.policyNumber = props.policy.policyNumber;
        memberData.employmentDate = _formatDate(memberData.employmentDate);
        memberData.effectiveDate = _formatDate(memberData.effectiveDate);
        memberData.dateOfBirth = _formatDate(memberData.dateOfBirth);
        memberData.allowModify = true;
        memberData.allowDelete = true;

        let dependentNoToUse = null;

        // create dummy member id
        if (memberData.relationship === '00') {
            let idToUse = maxIdsOnMemberObject?.maxSelfNo;

            memberData.memberNo = generateMemberId(++idToUse);
            memberData.parentMember = null;

            let newObject = {...maxIdsOnMemberObject};
            newObject[idToUse] = {
                spouseList: [],
                childList: []
            }
            newObject.maxSelfNo = idToUse;
            setMaxIdsOnMemberObject(newObject);
        }
        else if (props.policy?.allowDependent === 'Y' && memberData.relationship !== '00') {
            let parentNo = memberData.parentMember.substr(0, memberData.parentMember.indexOf('-'));
            dependentNoToUse = getDependentNumberToUse(memberData);
            memberData.memberNo = parentNo + '-' + dependentNoToUse;

            let parentDetailsArray = data.filter(member => member.relationship === '00' &&
                member.memberNo === memberData.parentMember && !member.securityId.startsWith('****'));
            if (parentDetailsArray.length > 0) {
                memberData.parentSecurityId = parentDetailsArray[0].securityId;
            }
        }

        if (memberData.planId === props.policy.planId && memberData.subsidiaryNo === props.policy.subsidiaryNo) {
            memberData.subsidiaryName = props.policy.subsidiaryName;
            memberData.planName = props.policy.planName;
            memberData.modified = true;
            props.storePoliciesForUpdate(memberData, "A");
            data.unshift(memberData);
            setData(data);
            props.syncMemberList(data);
        }
        else {
            memberData.subsidiaryName = getSubsidiaryName(memberData.subsidiaryNo);
            memberData.planName = getPlanName(memberData.planId);
            memberData.modified = true;
            if (memberData.subsidiaryNo !== props.policy.subsidiaryNo) {
                // Need to get new plan id from different subsidiary
                memberData.planId = getPlanId(memberData.subsidiaryNo, memberData.planName);
            }
            props.storePoliciesForUpdate(memberData, "A");

            // populate members if not exist
            let newMemberList = [];
            newMemberList.push(memberData);

            // If spouse/child exists, add too
            let members = findFamilyMembers(memberData);
            if (members) {
                members.map(m => {
                    m.subsidiaryName = memberData.subsidiaryName;
                    m.planName = memberData.planName;
                    m.planId = memberData.planId;
                    props.storePoliciesForUpdate(m, "A");
                    newMemberList.push(m);
                });
            }
            addToMemberList(newMemberList);
        }

        setAddUserDialog(false);
    }

    const editMember = (memberData) => {
        console.log('editMember', memberData);
        memberData.policyNumber = props.policy.policyNumber;
        memberData.employmentDate = _formatDate(memberData.employmentDate);
        memberData.effectiveDate = _formatDate(memberData.effectiveDate);
        memberData.dateOfBirth = _formatDate(memberData.dateOfBirth);

        if (props.policy?.allowDependent === 'Y') {
            if (memberData.relationship !== '00') {
                let parentNo = memberData.parentMember.substr(0, memberData.parentMember.indexOf('-'));
                let dependentNoToUse = getDependentNumberToUse(memberData);
                memberData.memberNo = parentNo + '-' + dependentNoToUse;
            }
            else {
                memberData.parentMember = null;
            }
        }

        if (memberData.planId === props.policy.planId && memberData.subsidiaryNo === props.policy.subsidiaryNo) {
            memberData.subsidiaryName = props.policy.subsidiaryName;
            memberData.planName = props.policy.planName;
            memberData.modified = true;
            // mark the member as update
            props.storePoliciesForUpdate(memberData, "E");
            data.splice(memberData.recordIdx, 1, memberData);
            props.syncMemberList(data);
        }
        else {
            memberData.subsidiaryName = getSubsidiaryName(memberData.subsidiaryNo);
            memberData.planName = getPlanName(memberData.planId);
            memberData.modified = true;
            if (memberData.subsidiaryNo !== props.policy.subsidiaryNo) {
                // Need to get new plan id from different subsidiary
                memberData.planId = getPlanId(memberData.subsidiaryNo, memberData.planName);
            }

            props.storePoliciesForUpdate(memberData, "C");
            // populate members if not exist
            let newMemberList = [];
            newMemberList.push(memberData);

            // remove from the current list
            data.splice(memberData.recordIdx, 1);

            // If spouse/child exists, add too
            let members = findFamilyMembers(memberData);
            if (members) {
                members.map(m => {
                    m.subsidiaryName = memberData.subsidiaryName;
                    m.planName = memberData.planName;
                    m.planId = memberData.planId;
                    props.storePoliciesForUpdate(m, "C");
                    newMemberList.push(m);

                    // remove from the current list
                    let indexToRemove = data.findIndex(m2 => m2.memberNo === m.memberNo)
                    data.splice(indexToRemove, 1);
                });
            }
            addToMemberList(newMemberList);

            props.syncMemberList(data);
        }

        setEditUserDialog(false);
        setChanged(true);
    }

    const getDependentNumberToUse = (memberData) => {
        let parentNo = memberData.parentMember.substr(0, memberData.parentMember.indexOf('-'));
        let dependentNoToUse = null;

        if (memberData.relationship === '01') {
            let nextSpouseNo = getNextDependentNumberSpouse(maxIdsOnMemberObject[Number(parentNo)].spouseList);

            let newObject = {...maxIdsOnMemberObject};
            newObject[Number(parentNo)].spouseList.push(nextSpouseNo);
            newObject[Number(parentNo)].spouseList.sort(sortingFunc);
            setMaxIdsOnMemberObject(newObject);

            dependentNoToUse = nextSpouseNo.toString().padStart(2,'0');
        } else if (memberData.relationship === '02') {
            let nextChildNo = getNextDependentNumberChild(maxIdsOnMemberObject[Number(parentNo)].childList);

            let newObject = {...maxIdsOnMemberObject};
            newObject[Number(parentNo)].childList.push(nextChildNo);
            newObject[Number(parentNo)].childList.sort(sortingFunc);
            dependentNoToUse = nextChildNo.toString().padStart(2,'0');
        }

        return dependentNoToUse;
    }

    const getNextDependentNumberSpouse = (list) => {
        if (list.length == 0) {
            return 1;
        }
        for (let i = 0; i < list.length; i++) {
            if (i == 0 && list[i] !== 1) {
                return 1;
            } else if (i == 1 && list[i] !== 31) {
                return 31;
            }
            if (i > 1 && i <= list.length - 2 && (list[i+1]-list[i] != 1)) {
                return ++list[i];
            }

            // check last element if did not go to any condition above
            if (i == list.length-1) {
                if (list[i] == 1) {
                    return 31;
                } else {
                    let result = list[i];
                    return ++result;
                }
            }
        }
    }

    const getNextDependentNumberChild = (list) => {
        if (list.length == 0) {
            return 2;
        }
        for (let i = 0; i < list.length; i++) {
            if (i == 0 && list[i] !== 2) {
                return 2;
            } else if (i == 19 && list[i] !== 100) {
                return 100;
            } else if (i > 0 && (list[i] <= 20 || list[i] >= 100) && i < list.length-2 && (list[i+1]-list[i] != 1)) {
                return ++list[i];
            }

            // check last element if did not go to any condition above
            if (i == list.length-1) {
                if (list[i] == 20) {
                    return 100;
                } else {
                    let result = list[i];
                    return ++result;
                }
            }
        }
    }

    const deleteMember = (memberData) => {
        console.log('deleteMember', memberData);
        memberData.subsidiaryName = props.policy.subsidiaryName;
        memberData.planName = props.policy.planName;
        memberData.policyNumber = props.policy.policyNumber;
        props.storePoliciesForUpdate(memberData, "D");
        data.splice(memberData.recordIdx, 1);
        props.syncMemberList(data);
        setDeleteUserDialog(false);
        setChanged(true);
    }

    const dateSortingFunction = (val1, val2, fieldName) => {
        let date1 = moment(val1[fieldName],'DD/MM/YYYY').toDate();
        let date2 = moment(val2[fieldName],'DD/MM/YYYY').toDate();
        return (date2 - date1);
    }

    const hasChange = () => {
        if (props.policiesForUpdate && props.policy.policyNumber) {
            let policy = props.policiesForUpdate.find((p) => { return p.policyNumber === props.policy.policyNumber });
            if (policy?.members?.length > 0) {
                let found = policy.members.find((p) => { return p.planId === props.policy.planId});
                return found ? true : false;
            }
        }
        return false;
    }

    const memberNoLabel = (memberNo, memberDetail) => {
        if (memberDetail.modified) {
            return "* " + memberNo;
        }
        return memberNo;
    }


    const columns = [
        {
            title: 'MEMBER ID',
            field: 'memberNo',
            render: rowData => <div>{ memberNoLabel(rowData.memberNo, rowData) }</div>
        },
        {
            title: 'RELATIONSHIP',
            field: 'relationship',
            render: rowData => <div>{ getRelationshipLabel(rowData.relationship) }</div>
        },
        {
            title: 'NAME',
            field: 'name',
            render: rowData => <StyledNameDiv onClick={() => callViewUserDialog(rowData)}>{rowData.name}</StyledNameDiv>
        },
        {title: 'EMPLOYMENT DATE', field: 'employmentDate',
            customSort: (val1, val2) => dateSortingFunction(val1, val2, 'employmentDate')},
        {title: 'EFFECTIVE DATE', field: 'effectiveDate',
            customSort: (val1, val2) => dateSortingFunction(val1, val2, 'effectiveDate')},
        {title: 'DATE OF BIRTH', field: 'dateOfBirth',
            customSort: (val1, val2) => dateSortingFunction(val1, val2, 'dateOfBirth')}
        ,{
            title: 'GENDER',
            field: 'gender',
            render: rowData => <div>{ getGenderLabel(rowData.gender) }</div>
         }
        ,{
            title: 'EMAIL',
            field: 'emailAddress'
        }
    ];

    const getPlanName = (planId) => {
        // set planName, subsidiaryName
        let plans = props.planList.filter(pl => pl.optionValue === planId);
        if (plans.length > 0) {
            return plans[0].optionLabel;
        }

        return '';
    }

    const getPlanId = (subsidiaryNo, planName) => {
        let planList = props.policyList[props.policy.policyIndex]
            .subsidiaryList.filter(sub => sub.subsidiaryNo === subsidiaryNo)
            .map(sub => {
                return sub.planList.filter(pl => pl.planName == planName);
            })
        return planList ? planList[0][0]?.planId : null;
    }

    const getSubsidiaryName = (subsidiaryNo) => {
        // set planName, subsidiaryName
        let subs = props.subsidiaryList.filter(pl => pl.optionValue === subsidiaryNo);
        if (subs.length > 0) {
            return subs[0].optionLabel;
        }

        return '';
    }

    const addToMemberList = (memberDataList) => {
        let memberData = memberDataList[0];
        let newMemberList = [];

        memberDataList.map(m => {
            let newMember = Object.assign({}, m);
            newMemberList.push(newMember);
        })

        let memberList = props.retrieveMemberList(memberData.subsidiaryNo, memberData.planId);
        if (!memberList) {
            console.log('build new member list for plan '+memberData.planName);
            props.retrieveMembers(memberData.planId).then((response) => {
                if (response) {
                    let memberResult = response.map(obj => {
                        let displayObj = Object.assign({}, obj);
                        displayObj.effectiveDate = _formatDate(obj.effectiveDate);
                        displayObj.employmentDate = _formatDate(obj.employmentDate);
                        displayObj.dateOfBirth = _formatDate(obj.dateOfBirth);
                        displayObj.memberNo = obj?.memberNo?.padStart(6, "0");
                        displayObj.policyNumber = obj?.policyNumber;
                        displayObj.subsidiaryNo = memberData.subsidiaryNo;
                        displayObj.subsidiaryName = memberData.subsidiaryName;
                        displayObj.planId = obj?.planId;
                        displayObj.planName = obj?.planName;
                        displayObj.relationship = obj?.relationship;
                        displayObj.lastServiceDate = _formatDate(obj?.lastServiceDate);
                        displayObj.name = obj.name;
                        displayObj.allowModify = props.policy.allowModify;
                        displayObj.allowDelete = props.policy.allowDelete;
                        return displayObj;
                    });
                    console.log("store members", memberResult);
                    props.storeMemberList(memberData.subsidiaryNo, memberData.planId, newMemberList.concat(memberResult));
                }
            });
        }
        else {
            let memberResult = memberList.map(obj => {
                let displayObj = Object.assign({}, obj);
                displayObj.effectiveDate = _formatDate(obj.effectiveDate);
                displayObj.employmentDate = _formatDate(obj.employmentDate);
                displayObj.dateOfBirth = _formatDate(obj.dateOfBirth);
                displayObj.memberNo = obj?.memberNo?.padStart(6, "0");
                displayObj.policyNumber = obj?.policyNumber;
                displayObj.subsidiaryNo = obj?.subsidiaryNo;
                displayObj.subsidiaryName = obj?.subsidiaryName;
                displayObj.planId = obj?.planId;
                displayObj.planName = obj?.planName;
                displayObj.relationship = obj?.relationship;
                displayObj.lastServiceDate = _formatDate(obj?.lastServiceDate);
                displayObj.name = obj.name;
                displayObj.allowModify = obj.allowModify;
                displayObj.allowDelete = obj.allowDelete;
                return displayObj;
            });
            console.log("store members", memberResult);

            props.storeMemberList(memberData.subsidiaryNo, memberData.planId, newMemberList.concat(memberResult));
        }
        setChanged(true);
    }

    const findFamilyMembers = (currMember) => {
        // if no parent, no family member returned
        if (!currMember.memberNo || !currMember.memberNo.endsWith("00")) {
            return null;
        }

        let memberId = currMember.memberNo?.substr(0, currMember.memberNo?.indexOf('-'));
        if (memberId) {
            return data.filter(m => m.memberNo.startsWith(memberId));
        }
        return null;
    }

    return (
        <div className={classes.page_container}>

            <StyledBreadCrumbDiv>
                <div onClick={() => history.push('/portfolio')}>{cfg('memberListing.dashboardBreadCrumb')} >&nbsp;</div><div className={classes.activeBreadcrumbLink}>{cfg("memberListing.title")}</div>
            </StyledBreadCrumbDiv>

            <TitleDiv>
                {cfg("memberListing.title")}
            </TitleDiv>

            <PolicyDiv>
                <div className="insideDiv">
                    <div>
                        <div className="iconDiv">
                            <img src={PolicyIconMedical} height="46" alt="Medical Policy" />
                        </div>
                        <div className="policyNumberDiv">
                            <div className="normal">{cfg('memberListing.groupMedical')}</div>
                            <div className="bold">{props.policy.policyNumber}</div>
                        </div>
                    </div>
                    <div className={classes.policy_date_status}>
                        <div className={classes.policy_titles}>{cfg('memberListing.policyPeriod')}</div>
                        <div className={classes.policy_date}>{props.policy.period}</div>
                        <div className='policy_status status_active'>{cfg('policyStatus', props.policy.status)}</div>
                    </div>
                </div>
            </PolicyDiv>

            <SubsidiaryTitleDiv>
                {props.policy.subsidiaryName}
            </SubsidiaryTitleDiv>

            {(changed || hasChange()) &&
                <AlertBar>
                    <img className="info_alert_icon" src={RedInfoIcon} height="46" alt="Info" />
                    <span>There are changes you made on the system. To confirm your changes, please click <em><a onClick={() => history.push('/portfolio')}>here</a></em> to navigate to the dashboard to <em><strong>Submit Changes</strong></em>.</span>
                </AlertBar>
            }

            <TableDiv>
                <MaterialUiTable columns={columns} data={data}
                                 title={<div className="tableTitle">{props.policy.planName + ' - Members'}</div>}
                                 onClickEdit={(rowData) => callEditUserDialog(rowData)}
                                 onClickDelete={(rowData) => callDeleteUserDialog(rowData)}
                />
            </TableDiv>
            <br/>

            <QnectButton field="backBtn" onClick={() => {history.push('/portfolio')}}/>
            <QnectButton field="addMember" className={classes.addMemberBtn}
                         onClick={() => {
                             setAddUserDialog(true)
                         }}/>

            <AddUserDialog open={openAddUserDialog}
                           onClose={() => setAddUserDialog(false)}
                           onOk={(memberData) => {
                               addMember(memberData)
                           }}
                           parentOptions={getParentMemberOptions(data)}
                           props={props}>
            </AddUserDialog>
            <EditUserDialog open={openEditUserDialog}
                            onClose={() => setEditUserDialog(false)}
                            onOk={(memberData) => editMember(memberData)}
                            heading={'Policy Number: ' + props.policy.policyNumber}
                            data={userDetail}
                            parentOptions={getParentMemberOptions(data)}
                            props={props}>
            </EditUserDialog>

            <DeleteUserDialog open={openDeleteUserDialog}
                              onClose={() => setDeleteUserDialog(false)}
                              heading={props.policy.policyNumber + ' / ' + (props.policy.subsidiaryName ?
                                  props.policy.subsidiaryName + ' / ' : '') + props.policy.planName}
                              onOk={memberData => deleteMember(memberData)}
                              parentOptions={getParentMemberOptions(data)}
                              data={userDetail}>
            </DeleteUserDialog>

            <ViewUserDialog open={openUserDetailsDialog} onClose={() => setUserDetailsDialog(false)}
                            heading={props.policy.policyNumber + ' / ' + (props.policy.subsidiaryName ?
                                props.policy.subsidiaryName + ' / ' : '') + props.policy.planName}
                            onOk={() => setUserDetailsDialog(false)}
                            parentOptions={getParentMemberOptions(data)}
                            data={userDetail}>
            </ViewUserDialog>
            <ScrollToTopButton></ScrollToTopButton>

            <br/>
        </div>
    );
};

const mapStateToProps = (state) => {
    return {
        policy: _getPolicy(state),
        policyList: _getPolicyList(state),
        policiesForUpdate: _getPoliciesForUpdate(state),
        subsidiaryList: _getSubsidiaryList(state),
        planList: _getPlanList(state),
        lang: _getLang(state)
    }
}

const mapDispatchToProps = {
    retrieveMembers: _retrieveMembers,
    showSpinner: _showSpinner,
    hideSpinner: _hideSpinner,
    storePolicyList: _storePolicyList,
    storePoliciesForUpdate: _storePoliciesForUpdate,
    syncMemberList: _syncMemberList,
    retrieveMemberList: _retrieveMemberList,
    storeMemberList: _storeMemberList
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PolicyDetail));
